import { render, staticRenderFns } from "./BaseWidgetConfig.vue?vue&type=template&id=46341d04&scoped=true&"
import script from "./BaseWidgetConfig.vue?vue&type=script&lang=ts&"
export * from "./BaseWidgetConfig.vue?vue&type=script&lang=ts&"
import style0 from "./BaseWidgetConfig.vue?vue&type=style&index=0&id=46341d04&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46341d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
